import axios from 'axios';
import { Action } from 'redux';

import { IRequestAction } from 'redux/root';
import { publicURL, publicGQL } from 'stubs';
import { ILOV } from 'stubs/graphql/lov';

// --------------
// Actions
// --------------
export enum LOV_ACTIONS {
  UPDATE_RETRIEVED_ITEM_LOV = 'LOV_ACTIONS/UPDATE_RETRIEVED_ITEM_LOV',
  UPDATE_RETRIEVED_MEMBERSHIP_TYPE_LOV = 'LOV_ACTIONS/UPDATE_RETRIEVED_MEMBERSHIP_TYPE_LOV',
  UPDATE_RETRIEVED_MEMBER_SOURCE_LOV = 'LOV_ACTIONS/UPDATE_RETRIEVED_MEMBER_SOURCE_LOV',
  UPDATE_RETRIEVED_DELIVERY_LOV = 'LOV_ACTIONS/UPDATE_RETRIEVED_DELIVERY_LOV',
}

// --------------
// Action types
// --------------
export interface IUpdateRetrievedItemLOV
  extends Action<LOV_ACTIONS.UPDATE_RETRIEVED_ITEM_LOV> {
  itemCategory: ILOV[];
  itemSubCategory: ILOV[];
  itemQuality: ILOV[];
  itemStyle: ILOV[];
  itemBrandCategory: ILOV[];
  itemSize: ILOV[];
  itemMaterial: ILOV[];
}
export interface IUpdateRetrievedMembershipTypeLOV
  extends Action<LOV_ACTIONS.UPDATE_RETRIEVED_MEMBERSHIP_TYPE_LOV> {
  membershipType: ILOV[];
}

export interface IUpdateRetrievedMemberSourceLOV
  extends Action<LOV_ACTIONS.UPDATE_RETRIEVED_MEMBER_SOURCE_LOV> {
  memberSource: ILOV[];
}

export interface IUpdateRetrievedDeliveryLOV
  extends Action<LOV_ACTIONS.UPDATE_RETRIEVED_DELIVERY_LOV> {
  deliveryType: ILOV[];
  deliveryTypeCollectStatus: ILOV[];
}

export type ILOVActions =
  | IUpdateRetrievedItemLOV
  | IUpdateRetrievedMembershipTypeLOV
  | IUpdateRetrievedMemberSourceLOV
  | IUpdateRetrievedDeliveryLOV;

// --------------
// Action creators
// --------------

export const retrieveAllLOVRequest = (): IRequestAction => async (dispatch) => {
  try {
    const query = publicGQL.allLOV;
    const res = await axios.post<any>(publicURL, { query });

    const itemCategoryLOV: ILOV[] = res.data.data.itemCategoryLOV;
    const itemSubCategoryLOV: ILOV[] = res.data.data.itemSubCategoryLOV;
    const itemQualityLOV: ILOV[] = res.data.data.itemQualityLOV;
    const itemStyleLOV: ILOV[] = res.data.data.itemStyleLOV;
    const itemBrandCategoryLOV: ILOV[] = res.data.data.itemBrandCategoryLOV;
    const itemSizeLOV: ILOV[] = res.data.data.itemSizeLOV;
    const itemMaterialLOV: ILOV[] = res.data.data.itemMaterialLOV;
    const membershipTypeLOV: ILOV[] = res.data.data.membershipTypeLOV;
    const memberSourceLOV: ILOV[] = res.data.data.memberSourceLOV;
    const deliveryTypeLOV: ILOV[] = res.data.data.deliveryTypeLOV;
    const deliveryTypeCollectStatusLOV: ILOV[] =
      res.data.data.deliveryTypeCollectStatusLOV;

    dispatch(
      updateRetrievedItemLOV(
        itemCategoryLOV,
        itemSubCategoryLOV,
        itemQualityLOV,
        itemStyleLOV,
        itemBrandCategoryLOV,
        itemSizeLOV,
        itemMaterialLOV
      )
    );
    dispatch(updateRetrievedMembershipTypeLOV(membershipTypeLOV));
    dispatch(updateRetrievedMemberSourceLOV(memberSourceLOV));
    dispatch(
      updateRetrievedDeliveryLOV(deliveryTypeLOV, deliveryTypeCollectStatusLOV)
    );

    return;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const retrieveItemLOVRequest =
  (): IRequestAction => async (dispatch) => {
    try {
      const query = publicGQL.itemLOV;
      const res = await axios.post<any>(publicURL, { query });

      const itemCategoryLOV: ILOV[] = res.data.data.itemCategoryLOV;
      const itemSubCategoryLOV: ILOV[] = res.data.data.itemSubCategoryLOV;
      const itemQualityLOV: ILOV[] = res.data.data.itemQualityLOV;
      const itemStyleLOV: ILOV[] = res.data.data.itemStyleLOV;
      const itemBrandCategoryLOV: ILOV[] = res.data.data.itemBrandCategoryLOV;
      const itemSizeLOV: ILOV[] = res.data.data.itemSizeLOV;
      const itemMaterialLOV: ILOV[] = res.data.data.itemMaterialLOV;

      dispatch(
        updateRetrievedItemLOV(
          itemCategoryLOV,
          itemSubCategoryLOV,
          itemQualityLOV,
          itemStyleLOV,
          itemBrandCategoryLOV,
          itemSizeLOV,
          itemMaterialLOV
        )
      );

      return;
    } catch (e) {
      return Promise.reject(e);
    }
  };

export const updateRetrievedItemLOV = (
  itemCategoryLOV: ILOV[],
  itemSubCategoryLOV: ILOV[],
  itemQualityLOV: ILOV[],
  itemStyleLOV: ILOV[],
  itemBrandCategoryLOV: ILOV[],
  itemSizeLOV: ILOV[],
  itemMaterialLOV: ILOV[]
): IUpdateRetrievedItemLOV => ({
  type: LOV_ACTIONS.UPDATE_RETRIEVED_ITEM_LOV,
  itemCategory: itemCategoryLOV,
  itemSubCategory: itemSubCategoryLOV,
  itemQuality: itemQualityLOV,
  itemStyle: itemStyleLOV,
  itemBrandCategory: itemBrandCategoryLOV,
  itemSize: itemSizeLOV,
  itemMaterial: itemMaterialLOV,
});

export const retrieveMembershipTypeLOVRequest =
  (): IRequestAction => async (dispatch) => {
    try {
      const query = publicGQL.membershipTypeLOV;
      const res = await axios.post<any>(publicURL, { query });

      const membershipTypeLOV: ILOV[] = res.data.data.membershipTypeLOV;

      dispatch(updateRetrievedMembershipTypeLOV(membershipTypeLOV));

      return;
    } catch (e) {
      return Promise.reject(e);
    }
  };

export const updateRetrievedMembershipTypeLOV = (
  membershipTypeLOV: ILOV[]
): IUpdateRetrievedMembershipTypeLOV => ({
  type: LOV_ACTIONS.UPDATE_RETRIEVED_MEMBERSHIP_TYPE_LOV,
  membershipType: membershipTypeLOV,
});

export const retrieveMemberSourceLOVRequest =
  (): IRequestAction => async (dispatch) => {
    try {
      const query = publicGQL.memberSourceLOV;
      const res = await axios.post<any>(publicURL, { query });

      const memberSourceLOV: ILOV[] = res.data.data.memberSourceLOV;

      dispatch(updateRetrievedMemberSourceLOV(memberSourceLOV));

      return;
    } catch (e) {
      return Promise.reject(e);
    }
  };

export const updateRetrievedMemberSourceLOV = (
  memberSourceLOV: ILOV[]
): IUpdateRetrievedMemberSourceLOV => ({
  type: LOV_ACTIONS.UPDATE_RETRIEVED_MEMBER_SOURCE_LOV,
  memberSource: memberSourceLOV,
});

export const updateRetrievedDeliveryLOV = (
  deliveryTypeLOV: ILOV[],
  deliveryTypeCollectStatusLOV: ILOV[]
): IUpdateRetrievedDeliveryLOV => ({
  type: LOV_ACTIONS.UPDATE_RETRIEVED_DELIVERY_LOV,
  deliveryType: deliveryTypeLOV,
  deliveryTypeCollectStatus: deliveryTypeCollectStatusLOV,
});
